import { Typography } from '@mui/material';

export function NotFoundPage() {
  return (
    <div>
      <Typography>404 - Page Not Found</Typography>
    </div>
  );
}
